import { Button, cn } from '@heroui/react'

export default function AuthButton({ children, className, ...props }) {
  return (
    <Button
      radius="none"
      size="lg"
      fullWidth
      className={cn(`bg-black font-taurus text-xl font-medium text-white`, className)}
      {...props}
    >
      {children}
    </Button>
  )
}
